import { NgModule } from '@angular/core';
import { FiltersChipListComponent } from './filters-chip-list.component';
import { SharedModule } from '@partner/shared/shared.module';

@NgModule({
  imports: [SharedModule],
  exports: [FiltersChipListComponent],
  declarations: [FiltersChipListComponent]
})
export class FiltersChipListModule { }
